//added by delon - 2025-03-26
import './css/mall_gallery.css';
import React, { useState, useRef, useEffect, ReactElement, Fragment } from 'react';
import axios from 'axios';
import InfinityEncryptor from '../../components/EncryptDecrypt/InfinityEncryptor';

//mui
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { itemsEqual } from '@dnd-kit/sortable/dist/utilities';

//classes
class Position {
    public x: number = 0;
    public y: number = 0;
}

const nonstate = {
    s3cr3t: 'ppkm_14082024_mobile',
    galleryURl: 'https://www.ppkm.org.my/mobile_backend/assets/highlights/index.php',
    landscapeControlUrl: 'https://www.ppkm.org.my/mobile_backend/assets/highlights/landscape/landscape_control.php',
    portraitControlUrl: 'https://www.ppkm.org.my/mobile_backend/assets/highlights/portrait_control.php'
};

interface Props {

}

const MallGallery: React.FC<Props> = ({ }) => {
    //states
    const [landscapes, SetLandscapes] = useState<string[]>([] as string[]);
    const [portraits, SetPortraits] = useState<string[]>([] as string[]);
    const [pageMode, SetPageMode] = useState('landscape'); //landscape, portrait
    const [holdingItem, SetHoldingItem] = useState<string>('');
    const [shadowPos, SetShadowPos] = useState<Position>({x: 0, y: 0} as Position);
    const [attemptToMoveItemToIndex, SetAttemptToMoveItemToIndex] = useState<number | null>(null);
    //refs
    const landscapesRef = useRef<string[]>(landscapes);
    const portraitsRef = useRef<string[]>(portraits);
    const holdingItemRef = useRef<string>(holdingItem);
    const holdingItemContainerRef = useRef<any>(null);
    const attemptToMoveItemToIndexRef = useRef<number | null>(attemptToMoveItemToIndex);
    const shouldAddItemCountRef = useRef<number>(0);
    const pageModeRef = useRef<string>(pageMode);

    //refs actions
    const mouseMoveActionRef = useRef<any>((e: any) => {
        // holdingItemContainerRef.current.style.top = e.clientY;
        // holdingItemContainerRef.current.style.top = e.clientX;

        SetShadowPos({x: e.clientX, y: e.clientY} as Position);
    });
    const mouseUpActionRef = useRef<any>(() => {
        if(
            attemptToMoveItemToIndexRef.current != null
        ) {
            // eslint-disable-next-line no-restricted-globals
            if(confirm('Are you sure you want to move the item here?')) {
                if(attemptToMoveItemToIndexRef.current != null)
                    MoveItemIndex(holdingItemRef.current, attemptToMoveItemToIndexRef.current);
            }
        }

        //reset everything
        holdingItemRef.current = '';
        SetHoldingItem(holdingItemRef.current);

        attemptToMoveItemToIndexRef.current = null;
        SetAttemptToMoveItemToIndex(attemptToMoveItemToIndexRef.current );
        document.removeEventListener('mouseup', mouseUpActionRef.current);
    });

    //controllers
    const encryptor = new InfinityEncryptor('22499', 'MYDIH');

    //watchers
    //test
    // useEffect(() => {
    //     console.log('mall_gallery_test: portraits: ' + JSON.stringify(portraits));
    //     console.log('mall_gallery_test: landscapes: ' + JSON.stringify(landscapes));
    // }, [landscapes, portraits]);

    //initialize
    useEffect(() => {
        //fetch portraits
        RefetchPortraitItems();

        //fetch landscapes
        RefetchLandscapeItems();
    }, []);

    //watch for holdingItem create shadowItem and update shadowpos
    useEffect(() => {
        if(holdingItem != '') {
            document.addEventListener('mousemove', mouseMoveActionRef.current);
        } else {
            document.removeEventListener('mousemove', mouseMoveActionRef.current);
        }
    }, [holdingItem]);

    //watch onPageMode update pageModeRef
    useEffect(() => {
        pageModeRef.current = pageMode;
    }, [pageMode]);

    //ui functions
    const OnItemsAdded = (e: any) => {
        if(e.target.files.length > 0) {
            const files = e.target.files;
            shouldAddItemCountRef.current = files.length;
            const _files = Array.from(files);

            _files.map((file: any) => {
                const reader = new FileReader();
                reader.onload = function(e2: any) {
                    const base64 = e2.target.result;
                    const formData = new FormData();
                    formData.append('addNewItem', 'true');
                    formData.append('base64', base64);

                    axios.post((pageModeRef.current == 'landscape' ? nonstate.landscapeControlUrl : nonstate.portraitControlUrl), formData, {withCredentials: false}).then((res: any) => {
                        if(!JSON.stringify(res.data).includes('_false')) {
                            shouldAddItemCountRef.current -= 1;

                            if(shouldAddItemCountRef.current == 0) {
                                alert('All items suffessfully added!');
                                if(pageModeRef.current == 'landscape')
                                    RefetchLandscapeItems();
                                else
                                    RefetchPortraitItems();
                            }
                        } else {
                            console.log('addNewItemErr: ' + res.data);
                        }
                    }).catch((err: string) => {
                        console.log('addNewItemErr: ' + err);
                    });
                };
                reader.readAsDataURL(file);
            });
        }
    }
    // const OnDeleteAllItemsClicked = () => {

    // }
    const OnRemoveItemClicked = (itemSubject: string, itemIndex: number) => {
        if(window.confirm('Are you sure to delete the selected item?')) {
            DeleteItem(itemSubject, itemIndex);
        }
    }
    const OnItemHold = (e: any, index: number) => {
        e.preventDefault();

        holdingItemRef.current = (pageModeRef.current == 'landscape' ? landscapes[index] : portraits[index]);
        SetHoldingItem(holdingItemRef.current);
        document.addEventListener('mouseup', mouseUpActionRef.current);
    }
    const OnMouseEnterItem = (index: number) => {
        if(
            holdingItemRef.current != ''
            && GetItemIndex(holdingItemRef.current) != index
        ) {
            attemptToMoveItemToIndexRef.current = index;
            SetAttemptToMoveItemToIndex(attemptToMoveItemToIndexRef.current);
        }
    }
    const OnMouseLeaveItem = (index: number) => {
        if(
            holdingItemRef.current != ''
            && attemptToMoveItemToIndexRef.current == index
        ) {
            attemptToMoveItemToIndexRef.current = null;
            SetAttemptToMoveItemToIndex(null);
        }
    }

    //render functions
    const RenderLandscapeGallery = () => {
        const gallery = [] as ReactElement[];
        landscapes.map((src: string, i: number) => {
            gallery.push(
                <div key={'gallery-item-' + i} className={'gallery-item ' + (attemptToMoveItemToIndex == i ? 'sort-before' : '')} onMouseDown={(e: any) => OnItemHold(e, i)} onMouseEnter={() => OnMouseEnterItem(i)} onMouseLeave={() => OnMouseLeaveItem(i)}>
                    <img className='gallery-img' src={src} draggable={false}/>
                    <button className='gallery-btn' onClick={() => OnRemoveItemClicked(src, i)}><DeleteIcon /></button>
                </div>
            );
        });

        return(
            <Fragment>
                {gallery}
            </Fragment>
        )
    }
    const RenderPortraitGallery = () => {
        const gallery = [] as ReactElement[];
        portraits.map((src: string, i: number) => {
            gallery.push(
                <div key={'gallery-item-' + i} className={'gallery-item ' + (attemptToMoveItemToIndex == i ? 'sort-before' : '')} onMouseDown={(e: any) => OnItemHold(e, i)} onMouseEnter={() => OnMouseEnterItem(i)} onMouseLeave={() => OnMouseLeaveItem(i)}>
                    <img className='gallery-img' src={src} draggable={false}/>
                    <button className='gallery-btn' onClick={() => OnRemoveItemClicked(src, i)}><DeleteIcon /></button>
                </div>
            );
        });

        return(
            <Fragment>
                {gallery}
            </Fragment>
        )
    }

    //exe functions
    const MoveItemIndex = (subjectItem: string, newIndex: number) => {
        const formData = new FormData();
        formData.append('moveItemIndex', 'true');
        formData.append('subjectItem', subjectItem);
        const _newIndex = (GetItemIndex(subjectItem) < newIndex ? (newIndex - 1) : newIndex).toString();
        formData.append('newIndex', _newIndex);

        console.log('checkPageMode: ' + pageModeRef.current);

        if(pageModeRef.current == 'landscape') {
            axios.post(nonstate.landscapeControlUrl, formData, {withCredentials: false}).then((res: any) => {
                if(!JSON.stringify(res.data).includes('_false')) {
                    alert('Successfully moved an item!');
                    RefetchLandscapeItems();
                } else {
                    console.log('MoveItemIndexLandscapeErr: ' + res.data);
                }
            }).catch((err: string) => {
                console.log('MoveItemIndexLandscapeErr: ' + err);
            });
        } else {
            axios.post(nonstate.portraitControlUrl, formData, {withCredentials: false}).then((res: any) => {
                console.log('checkPortraitMoveRes: ' + res.data);
                if(!JSON.stringify(res.data).includes('_false')) {
                    alert('Successfully moved an item!');
                    RefetchPortraitItems();
                } else {
                    console.log('MoveItemIndexPortraitErr: ' + res.data);
                }
            }).catch((err: string) => {
                console.log('MoveItemIndexPortraitErr: ' + err);
            });
        }
    }
    const GetItemIndex = (itemSubject: string) => {
        let res = 0;
        if(pageModeRef.current == 'landscape') {
            landscapesRef.current.map((landscape: string, i: number) => {
                if(itemSubject == landscape)
                    res = i;
            });
        } else if(pageModeRef.current == 'portrait') {
            portraitsRef.current.map((portrait: string, i: number) => {
                if(itemSubject == portrait)
                    res = i;
            });
        }
        return res;
    }
    const RefetchLandscapeItems = () => {
        const formData_landscape = new FormData();
        formData_landscape.append('s3cr3t', encryptor.Encrypt(nonstate.s3cr3t));
        formData_landscape.append('fetchHighlightProfiles', encryptor.Encrypt('true'));
        formData_landscape.append('landscape', encryptor.Encrypt('true'));
        axios.post(nonstate.galleryURl, formData_landscape, { withCredentials: false }).then((res: any) => {
            if(res.data) {
                let resData = encryptor.Decrypt(res.data);
                let resArrs = [] as any[];
                resArrs = JSON.parse(resData) as any[];

                landscapesRef.current = resArrs.map((res: any) => res.src);
                SetLandscapes([...landscapesRef.current]);
            } else {
                console.log('fetchHighlightProfilesErr: ' + JSON.stringify(res));
            }
        }).catch((err: string) => {
            console.log('axiosPostErr: ' + err);
        });
    }
    const RefetchPortraitItems = () => {
        const formData_portrait = new FormData();
        formData_portrait.append('s3cr3t', encryptor.Encrypt(nonstate.s3cr3t));
        formData_portrait.append('fetchHighlightProfiles', encryptor.Encrypt('true'));
        axios.post(nonstate.galleryURl, formData_portrait, { withCredentials: false }).then((res: any) => {
            if(res.data) {
                let resData = encryptor.Decrypt(res.data);
                let resArrs = [] as any[];
                resArrs = JSON.parse(resData) as any[];

                portraitsRef.current = resArrs.map((res: any) => res.src);
                SetPortraits([...portraitsRef.current]);
            } else {
                console.log('fetchHighlightProfilesErr: ' + JSON.stringify(res));
            }
        }).catch((err: string) => {
            console.log('axiosPostErr: ' + err);
        });
    }
    const DeleteItem = (itemSubject: string, itemIndex: number) => {
        const formData = new FormData();
        formData.append('deleteItem', 'true');
        formData.append('itemSubject', itemSubject);
        formData.append('itemIndex', itemIndex.toString());

        if(pageModeRef.current == 'landscape') {
            axios.post(nonstate.landscapeControlUrl, formData, {withCredentials: false}).then((res: any) => {
                if(!JSON.stringify(res.data).includes('_false')) {
                    console.log('check res: ' + res.data);
                    alert('Successfully deleted an item!');
                    RefetchLandscapeItems();
                } else {
                    console.log('DeleteItemErr: ' + res.data);
                }
            }).catch((err: string) => {
                console.log('DeleteItemErr: ' + err);
            });
        } else {
            axios.post(nonstate.portraitControlUrl, formData, {withCredentials: false}).then((res: any) => {
                if(!JSON.stringify(res.data).includes('_false')) {
                    alert('Successfully deleted an item!');
                    RefetchPortraitItems();
                } else {
                    console.log('DeleteItemErr: ' + res.data);
                }
            }).catch((err: string) => {
                console.log('DeleteItemErr: ' + err);
            });
        }
    }

    return (
        <div className='MallGallery'>
            <div className='option-panel'>
                <button className={'option-btn ' + (pageMode == 'landscape' ? 'selected' : '')} onClick={() => SetPageMode('landscape')}>Landscape</button>
                <button className={'option-btn ' + (pageMode == 'portrait' ? 'selected' : '')} onClick={() => SetPageMode('portrait')}>Portrait</button>
                <label className='option-btn selected' htmlFor="option-file-selector">
                    <AddIcon />
                    Add New Pictures
                </label>
                <input id='option-file-selector' className='option-in selected' type='file' accept="image/*" onChange={(e: any) => OnItemsAdded(e)} multiple style={{ display: 'none' }}/>
                {/* <button className='option-btn selected' onClick={() => OnDeleteAllItemsClicked()}><DeleteIcon /> Delete All Pictures</button> */}
            </div>
            <div className='gallery-scroll'>
                {
                    pageMode == 'landscape'?
                        RenderLandscapeGallery()
                        :
                        RenderPortraitGallery()
                }
                <img ref={holdingItemContainerRef} className={'holding-item ' + (holdingItem != '' ? 'show' : 'hide')} src={holdingItem} style={{left: shadowPos.x, top: shadowPos.y}}/>
            </div>
        </div>
    );
}
export default MallGallery;